import React from 'react'

const Terms_Condition = () => {
    return (
        <div style={{ whiteSpace: "pre-wrap", lineHeight: "1.3", margin: "20px", fontSize: "12px" }}>
            <h2 style={{ textAlign: "center" }}>WearMirror Privacy Policy</h2>

            <p>
                This Privacy Policy explains how WearMirror ("we," "us," or "our") collects, uses, shares, and protects your information when you use our mobile application ("App") and related services ("Services").
            </p>

            <h3>1. Information We Collect</h3>

            <p><strong>Personal Information You Provide:</strong></p>
            <ul>
                <li><strong>Account Information:</strong> When creating an account, you may provide your name, email address, and phone number.</li>
                <li><strong>Device Information:</strong> We may collect details about your device such as type, OS, and unique identifiers.</li>
                <li><strong>Usage Data:</strong> Includes your interactions within the App, such as features accessed, duration of usage, and actions taken.</li>
            </ul>

            <p><strong>Automatically Collected Information:</strong></p>
            <ul>
                <li><strong>Location Data:</strong> We may collect GPS-based location data, if you grant permission, to provide location-based features.</li>
                <li><strong>Additional Usage Data:</strong> Such as time spent on the App and how you interact with its features.</li>
            </ul>

            <h3>2. How We Use Your Information</h3>
            <ul>
                <li><strong>To provide and improve Services:</strong> For personalization, feature development, and technical support.</li>
                <li><strong>To communicate with you:</strong> Sending updates, notifications, and service-related messages.</li>
                <li><strong>To personalize experiences:</strong> Recommending relevant content or features.</li>
                <li><strong>Marketing and advertising:</strong> We may send you promotional content. You can opt out at any time.</li>
                <li><strong>Legal compliance:</strong> To fulfill obligations under applicable laws and prevent misuse or fraud.</li>
            </ul>

            <h3>3. Data Sharing and Disclosure</h3>
            <ul>
                <li><strong>Third-party service providers:</strong> For analytics, hosting, and marketing support.</li>
                <li><strong>Business partners:</strong> For collaborative marketing and promotions.</li>
                <li><strong>Legal authorities:</strong> When required by law or under valid legal process.</li>
            </ul>

            <h3>4. Data Security</h3>
            <p>
                We implement reasonable security measures to protect your information. However, no method of transmission or storage is 100% secure.
            </p>

            <h3>5. Children's Privacy</h3>
            <p>
                Our Services are not intended for children under 18. We do not knowingly collect personal data from minors.
            </p>

            <h3>6. Your Rights (Under Indian Law)</h3>
            <p>You may have the right to:</p>
            <ul>
                <li>Access your personal data</li>
                <li>Request corrections</li>
                <li>Request deletion (under certain conditions)</li>
                <li>Restrict processing of your data</li>
                <li>Request data portability</li>
                <li>Object to processing in specific situations</li>
            </ul>

            <h3>7. Changes to This Policy</h3>
            <p>
                We may update this Privacy Policy from time to time. Material changes will be communicated through the App or other means.
            </p>

            <h3>8. Contact Us</h3>
            <p>
                If you have any questions, concerns, or feedback, please contact us at: Insert Contact Information
            </p>

            <h4>Disclaimer:</h4>
            <p>
                This sample Privacy Policy is for informational purposes and may not suit all use cases. We recommend consulting legal counsel to ensure compliance with applicable data protection laws.
            </p>

            <h4>Key Considerations for Indian Users:</h4>
            <ul>
                <li><strong>Data Localization:</strong> Include clauses about data storage within India, if applicable.</li>
                <li><strong>Consent:</strong> Ensure explicit user consent for collecting and processing personal information.</li>
                <li><strong>Legal Compliance:</strong> Follow India’s Information Technology Act, 2000 and related data privacy rules.</li>
            </ul>
        </div>
    );

}

export default Terms_Condition